// Localisation
let plyrLocalization = {
    restart         : 'Recommencer',
    rewind          : 'Rebobiner {seektime}s',
    play            : 'Jouer',
    pause           : 'Pause',
    fastForward     : 'Avance rapide {seektime}s',
    seek            : 'Saut',
    seekLabel       : '{currentTime} de {duration}',
    played          : 'Joué',
    buffered        : 'En mémoire',
    currentTime     : 'Temps actuel',
    duration        : 'Durée',
    volume          : 'Volume',
    mute            : 'Désactiver le son',
    unmute          : 'Activer le son',
    enableCaptions  : 'Afficher les sous-titres',
    disableCaptions : 'Cacher les sous-titres',
    download        : 'Télécharger',
    enterFullscreen : 'Mode plein écran',
    exitFullscreen  : 'Sortir du mode plein écran',
    frameTitle      : 'Lecteur pour {title}',
    captions        : 'Sous-titres',
    settings        : 'Options',
    pip             : "Incrustage d'image",
    menuBack        : 'Retour au menu précédant',
    speed           : 'Vitesse',
    normal          : 'Normal',
    quality         : 'Qualité',
    loop            : 'Lecture en boucle',
    start           : 'Début',
    end             : 'Fin',
    all             : 'Tous',
    reset           : 'Recommencer',
    disabled        : 'Désactivé',
    enabled         : 'Activé',
    advertisement   : 'Pub',
    qualityBadge    : {
        2160 : '4K',
        1440 : 'HD',
        1080 : 'HD',
        720  : 'HD',
        576  : 'SD',
        480  : 'SD',
    },
};

export default plyrLocalization;
